import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { useConfig } from "../lib/config";
import { useI18n } from "../context/I18nContext";

const cols = (t) => [
  { h: t("nav_shop"), links: [[t("c_seeds"), "/marketplace?category=seeds"], [t("c_fertilizers"), "/marketplace?category=fertilizers"], [t("c_machinery"), "/marketplace?category=machinery"], [t("c_irrigation"), "/marketplace?category=irrigation"]] },
  { h: t("f_for_farmers"), links: [[t("f_sell"), "/signup"], [t("f_find_farms"), "/farmers"], [t("f_crop_advisor"), "/ai-tools"], [t("f_disease"), "/ai-tools"]] },
  { h: t("f_company"), links: [[t("f_about"), "/about"], [t("f_contact"), "/contact"], [t("f_privacy"), "/privacy"], [t("f_terms"), "/terms"]] },
];

export default function Footer() {
  const cfg = useConfig();
  const { t } = useI18n();
  return (
    <footer className="mt-12 border-t border-border/60 bg-accent/30">
      <div className="max-w-7xl mx-auto px-6 py-12 grid sm:grid-cols-2 md:grid-cols-4 gap-8">
        <div>
          <Link to="/" className="flex items-center gap-2 mb-3">
            <img src="/logo.webp" alt="ULUME.shop" width="180" height="112" className="h-24 w-auto object-contain dark:bg-white dark:rounded-lg dark:p-2" />
          </Link>
          <p className="text-sm text-muted-foreground max-w-xs">{t("f_tag")}</p>
          {cfg.support_email
            ? <a href={`mailto:${cfg.support_email}`} className="mt-3 inline-flex items-center gap-2 text-sm text-primary hover:underline"><Mail className="w-4 h-4" />{cfg.support_email}</a>
            : <Link to="/contact" className="mt-3 inline-flex items-center gap-2 text-sm text-primary hover:underline"><Mail className="w-4 h-4" />{t("f_contact_us")}</Link>}
        </div>
        {cols(t).map(c => (
          <div key={c.h}>
            <h4 className="font-semibold mb-3 text-sm">{c.h}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {c.links.map(([label, to]) => (
                <li key={label}><Link to={to} className="hover:text-primary transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-border/60 py-4 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} ULUME. All rights reserved.
      </div>
    </footer>
  );
}
